import React from 'react';

export const Skeleton = ({ className = '' }: { className?: string }) => {
  return (
    <div 
      className={`animate-pulse bg-slate-200 dark:bg-slate-800 rounded-lg ${className}`} 
    />
  );
};
